/**
 * The rocketchat module's frontend manifest — everything it adds to the
 * interface, in one place. The backend half is `backend/src/modules/rocketchat/`.
 */
import { defineFrontendModule } from '../types';
import { OwnRocketChatHandlePanel } from './OwnRocketChatHandlePanel';
import { RocketChatHandlePanel } from './RocketChatHandlePanel';

export const rocketchatModule = defineFrontendModule({
  key: 'rocketchat',
  pages: [],
  slots: {
    // Core's permissions: a chat username is part of the account. The panel
    // shows it with `user.read` and offers editing only with `user.update`.
    'user.detail.sections': [{ id: 'handle', anyOf: ['user.read'], component: RocketChatHandlePanel }],
    // Everybody's own, read only: a session is enough.
    'profile.sections': [{ id: 'handle', component: OwnRocketChatHandlePanel }],
  },
});
